<template>
  <el-dialog
    :visible.sync="show"
    width="1024px"
    :title="title"
    close-on-click-modal
    class="dialog_center_type trems_dialog"
    @close="close"
  >
    <div v-if="fileType == 'pdf' || fileType == 'PDF'" v-loading="loadedRatio < 1">
      <pdf
        v-if="show"
        ref="pdf"
        :src="fileUrl"
        :page="pageNum"
        @progress="loadedRatio = $event"
        @num-pages="pageTotalNum=$event"
      ></pdf>
    </div>
    <div v-else>
      <el-image style="width: 100%; height: 100%" :src="fileUrl"></el-image>
    </div>
    <div slot="footer" class="pdf_view_footer">
      <div class="page_control">
        <el-button
          v-if="pageTotalNum > 1"
          type="primary"
          icon="el-icon-arrow-left"
          circle
          @click="prePage"
        ></el-button>
        <span>&nbsp;{{pageNum}}/{{pageTotalNum}}&nbsp;</span>
        <el-button
          v-if="pageTotalNum > 1"
          type="primary"
          icon="el-icon-arrow-right"
          circle
          @click="nextPage"
        ></el-button>
      </div>
      <div class="pdfview_btns">
        <!-- <el-button
          v-if="!isLocal && !$store.state.isApp"
          type="primary"
          icon="el-icon-download"
          @click="download"
        >{{$t('message.download')}}</el-button>
        <a
          v-if="isLocal && !$store.state.isApp"
          :class="`el-button el-button--primary`"
          :href="`${fileUrl}`"
          target="_blank"
          :download="filename"
        >
          <i class="el-icon-download"></i>
          {{$t('message.download')}}
        </a>-->
        <el-button @click="close">{{$t('message.close')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import pdf from "vue-pdf";
export default {
  components: { pdf },
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "",
    },
    fileUrl: String,
    fileType: String,
    isLocal: Boolean,
    filename: String,
  },
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0, //加載進度
      localPath: "",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    download() {
      window.open(this.fileUrl);
    },
    prePage() {
      var p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
    },
    nextPage() {
      var p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
    },
  },
  created() {
    this.localPath = process.env.VUE_APP_BASE_LOCAL_PATH;
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  overflow: hidden;
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    min-height: 200px;
  }
  .el-button + .el-button {
    margin-left: 10px;
  }
}
.page_control {
}
.pdf_view_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pdfview_btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .el-button {
    margin-top: 0 !important;
    text-align: right;
    margin-left: 20px !important;
  }
}
@media screen and (max-width: 767px) {
  .pdf_view_footer {
    display: block;
  }
  /deep/.el-dialog {
    .el-dialog__footer {
      text-align: right;
    }
  }
  .page_control {
    text-align: center;
  }

  .pdfview_btns {
    margin-top: 20px;
    justify-content: flex-end;
  }
}
</style>